import type { DraftItem } from "./types";

export const API_BASE_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:8080";

export const INITIAL_ITEM: DraftItem = {
  product_name: "",
  quantity: 1,
  unit_price: null,
};
